import React, { useState, useEffect } from 'react';
import { ButtonGroup, Input, Button } from '@tencent/spaui';
import { RPCFactory } from '../../../../utils/RequestUtil';

import useList from '../../../../leads_component/shared-components/hooks/useList';
import useInput from '../../../../leads_component/shared-components/hooks/useBasicInput';
import { genBasicHooks } from '../../../../leads_component/shared-components/plugins/helper';
import { useInputMaxCharLengthPlugin } from '../../../../leads_component/shared-components/plugins/input-plugins';
import useEdit from './useEdit';
import Picker from '../../../common/picker';
import StrategyRadio from './radio';
import RuleApplyRange from '../../../common/RuleApplyRange';
import useRuleApplyRange from '../../../hooks/useRuleApplyRange';

import { scopeMapToList, getKeys } from './helper';
import { scopeMap, roleTarget } from './config';

const editContent = (props) => {
  const content = props.data || {};
  // const {isXundaAccount} = props;
  const { model = 'add', data = {} } = props || {};

  const { ruleName = '未知', applyRange = {} } = data;
  const {
    strategyHooks,
    strategy,
    setStrategy,
    selectedDistributor,
    // setSelectedDistributor: setSelectedEmployeeDistributor,
    setSelectedEmployeeDistributor,
    setSelectedGroupDistributor,
    totalListOfDistributor,
    targetName,
    targetKey,
    targetSearchFields,
    strategyMap,
    target,
    setTarget,
    ruleSource,
    setRuleSource,
  } = useEdit(props);
  const scopeHooks = useList({
    emptyItem: { key: '', value: '' },
  });
  const nameHooks = genBasicHooks(useInput, { value: model == 'edit' ? ruleName : '' }).usePlugin(
    useInputMaxCharLengthPlugin,
    { maxLength: 20 },
  );
  const [showError, setShowError] = useState(false);
  const [selectData, setSelectData] = useState(
    Object.keys(scopeMap).map((key) => ({
      value: key,
      lable: scopeMap[key],
    })),
  );
  const applyRangeHooks = useRuleApplyRange({
    data: applyRange,
    model,
  });

  const isLast = model == 'edit' && data.isLast;
  useEffect(() => {
    if (props.model == 'edit') {
      setStrategy(content.leadsDistriStrategy);
      setTarget(data.leadsDistriTarget);
      setRuleSource(data.source);
      if (data.leadsDistriTarget === 'USER') {
        setSelectedEmployeeDistributor(content.leadsDistriEmployees);
      } else {
        setSelectedGroupDistributor(content.leadsDistriGroups);
      }
      scopeHooks.setDataList(scopeMapToList(content.scopeDetail));
    } else {
      scopeHooks.onAdd();
      setRuleSource(0);
      setStrategy('RULE_TOTAL_AVG');
    }
  }, []);

  useEffect(() => {
    const map = getKeys(scopeHooks.dataList);

    const data = Object.keys(scopeMap).map((key) => ({
      value: key,
      label: scopeMap[key],
      disabled: !!map[key],
    }));

    setSelectData(data);
  }, [scopeHooks.dataList]);

  const onSubmit = () => {
    if (nameHooks.props.value == null || nameHooks.props.value == '') {
      alert('请输入线索分配名称');
      return;
    }
    if (
      applyRangeHooks.applyRange.applyRangeType != 'ELSE' &&
      applyRangeHooks.applyRange.applyRangeDetail.length == 0
    ) {
      alert('请添加线索分配范围');
      return;
    }

    if (strategy == '') {
      alert('请选择分配规则');
      return;
    }

    if (!selectedDistributor || selectedDistributor.length == 0) {
      setShowError(true);
      return;
    }

    if (!applyRangeHooks.checkValid()) {
      return;
    }
    const params = {
      ruleName: nameHooks.props.value,
      leadsDistriTarget: target,
      leadsDistriStrategy: strategy,
      ...(target === 'USER'
        ? { leadsDistriEmployees: selectedDistributor }
        : { leadsDistriGroups: selectedDistributor }),
      applyRange: isLast ? { applyRangeType: 'ELSE' } : applyRangeHooks.applyRange,
      source: ruleSource,
    };

    let method = RPCFactory.leadsSetting.addCustomizedRules;

    if (props.model == 'edit') {
      params.ruleId = content.ruleId;
      method = RPCFactory.leadsSetting.updateCustomizedRules;
    }

    method(params)
      .done((data) => {
        props.onSubmit();
      })
      .fail((code, msg) => {
        alert(msg);
      });
  };

  const renderTarget = () => (
    <div className="config-li">
      <div className="form-in">
        <div className="interface-setting" style={{ width: '-webkit-fill-available' }}>
          <ButtonGroup
            className="scope-switch"
            data={Object.keys(roleTarget).map((key) => ({
              value: key,
              label: roleTarget[key],
            }))}
            disabled={ruleSource !== 0}
            value={target}
            onChange={(event, value, buttonProps) => {
              setTarget(value);
              console.log(value);
            }}
          />
        </div>
      </div>
    </div>
  );
  const renderScope = () => {
    if (content.applyRange && content.applyRange.applyRangeType == 'ELSE') {
      return null;
    }
    return (
      <div className="config-li">
        <em className="tt">规则名称</em>
        <div className="form-in">
          <Input {...nameHooks.props} disabled={isLast} />
        </div>
        {ruleSource !== 0 && (<div style={{ color: 'red' }}>说明: 讯达账号仅支持更改分配规则，若要修改楼盘与团队分配关系，请在“团队设置”-“楼盘-团队管理”中设置</div>)}
        <div className="form-in"></div>
        <div className="form-in">
          <RuleApplyRange {...applyRangeHooks} disabledAllField={isLast || ruleSource !== 0} source={ruleSource} />
        </div>
      </div>
    );
  };
  const renderEditPicker = () => (
    <div id="customUserPicker">
      <Picker
        valueKey={targetKey}
        targetName={targetName}
        searchPlaceholder={`搜索${targetName}名称`}
        searchFields={targetSearchFields}
        data={totalListOfDistributor}
        value={selectedDistributor}
        disabled={ruleSource !== 0}
        // InfoComponent={InfoComponent}
        onChange={(e, value) => {
          setShowError(false);
          if (target === 'USER') {
            setSelectedEmployeeDistributor(value);
          } else {
            setSelectedGroupDistributor(value);
          }
        }}
      />
      {showError ? <div className="error-text">{`请选择分配${targetName}`}</div> : null}
    </div>
  );
  return (
    <div className="page-manage-set">
      <div className="panel base-set">
        {renderScope()}
        {renderTarget()}
        <em className="tt">分配规则</em>
        <div className="rules">
          <div className="spa-ui-group with-vertical spaui-component">
            <StrategyRadio {...strategyHooks} strategyMap={strategyMap} />
          </div>
        </div>
        <div className="panel base-set">
          <em className="tt">
            <strong>{`分配${targetName}`}</strong>
          </em>
          <div className="rules">
            {renderEditPicker()}
          </div>
        </div>
      </div>
      <div className="btnline">
        <Button onClick={props.onCancel}>取消</Button>
        <Button bsStyle="primary" onClick={onSubmit}>
          提交
        </Button>
      </div>
    </div>
  );
};

export default editContent;
